/**
 * Created by Макс on 31.10.2017.
 */
/**
 * Created by Макс on 16.10.2017.
 */
import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { responseGetDashboard } from '../class/http/res/response-get-dashboard';

@Component({
    selector: 'dealer-dashboard-settings-comp',
    templateUrl: 'dashboard-settings/index.html',
    styleUrls: ['add-access/bootstrap.min.css', 'add-access/update.css', 'add-access/style.css', 'dashboard-settings/style.css'], //left-menu/style.min.css
})
export class DealerDashboardSettingsComponent {
    list: any;
    dealerGroupId: number;
    sub: any;
    DataDasborad = { name: "", link: "" };
    AddMode: boolean = false;
    constructor(
        private broadcaster: Broadcaster,
        private elementRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() {
        /*
     if (!this.httpService.getAuthData()) {
     window.location.pathname = '/';
     }
     this.broadcaster.on<string>('AuthError').subscribe(message => {
     console.log('message', message);
     if (message === '401') {
     this.httpService.LogOut().subscribe(data => {
     if (data.status === 401) {
     window.localStorage.clear();
     window.sessionStorage.clear();
     window.location.pathname = '/';
     }
     });
     }
     });*/
        /* this.broadcaster.on<any>('rooftops').subscribe(data => {
             this.rightMenu = data.iteшвшвidid
             wefwefwefwefms;
         });*/
        this.sub = this.route.queryParams.subscribe(params => {
            // Defaults to 0 if no query param provided.
            this.dealerGroupId = +params['id'] || 0;
            this.httpService
                .getDashboard(this.dealerGroupId)
                .subscribe((data:responseGetDashboard) => {
                    //  console.log('data', data);
                   
                        for (let i = 0; i < data.list.length; i++) {
                            data.list[i].editMode = false;
                        }
                        this.list = data.list;
                    
                    //  console.log("this.list", this.list);
                });
        });
    }
    EditDashboardToggle(i: number) {
        // console.log("this.list[i]", this.list[i]);
        if (this.list[i].editMode) {
            this.list[i].editMode = false;
        }
        else {
            this.list[i].editMode = true;
        }
    }
    EditDashboard(i: number) {
        let data = {
            id: this.list[i].dashboardId,
            name: this.list[i].name,
            url: this.list[i].url
        };
        this.httpService
            .saveDashboard(data)
            .subscribe(data => {
                // console.log('data', data);
                if (data.status === 200) {
                    this.list[i].editMode = false;
                }
            });
    }
    RemoveDashboard(i: number) {
        this.httpService
            .removeDashboard(this.list[i].dashboardId)
            .subscribe(data => {
                //  console.log('data', data);
                if (data.status === 200) {
                    this.list.splice(i, 1);
                }
            });
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    Save() {
        this.httpService
            .addDashboard(this.dealerGroupId, this.DataDasborad.name, this.DataDasborad.link)
            .subscribe(data => {
                // console.log('data', data);
                if (data.status === 200) {
                    this.DataDasborad = { name: "", link: "" };
                    this.AddMode = false;
                    data.data.editMode = false;
                    this.list.push(data.data);
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-dashboard-settings.component.ts